<template>
    <div class="vue-contact-person-card">
        <div class="body-content" v-html="contactPerson.body"></div>

        <ul class="contact-options">
            <li>
                <a :href="contactPerson.phone_number.uri">{{ contactPerson.phone_number.title }}</a>
            </li>
            <li>
                <a :href="contactPerson.whatsapp.uri">{{ contactPerson.whatsapp.title }}</a>
            </li>
            <li>
                <a :href="contactPerson.email.uri">{{ contactPerson.email.title }}</a>
            </li>
        </ul>

        <img :src="contactPerson.image.url" :alt="contactPerson.image.alt" class="person-image">
    </div>
</template>

<script>
export default {
    name: "ContactPersonCard",

    props: {
        contactPerson: {
            type: Object,
            required: true,
        }
    }
}
</script>